import { render, staticRenderFns } from "./CandidateVacancySource.vue?vue&type=template&id=2f6f13e8&scoped=true"
import script from "./CandidateVacancySource.vue?vue&type=script&lang=js"
export * from "./CandidateVacancySource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f13e8",
  null
  
)

export default component.exports